import Vue from "vue";
import Select2 from 'vue3-select2-component';
import App from "./App.vue";
import router from "./routes.js";
import { guest } from "./plugins/axios";
import { store } from "./store/store";
import jQuery from 'jquery';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import moment from "moment";
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import vSelect from 'vue-select' 
import VueSimpleSuggest from 'vue-simple-suggest'
window.swal = require('sweetalert2')

Vue.use(VueSweetalert2);
Vue.use(CKEditor);

Vue.use(datePicker);
Vue.config.productionTip = false;
import Select2MultipleControl from 'v-select2-multiple-component';

Vue.component('Select2MultipleControl', Select2);
Vue.component('v-select', vSelect)
Vue.component('vue-simple-suggest', VueSimpleSuggest)
new Vue({
  router,
  guest,
  store,
  Select2,
  Select2MultipleControl,
  jQuery,
  moment,
  VueSimpleSuggest,
  render: (h) => h(App),
}).$mount("#app");
